
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class HowXt extends Vue {
  status: 'init' | 'play' | 'pause' = 'init'

  @Ref()
  howXtVideo: {
    handlePlay: () => void
  } | null

  get options() {
    return {
      video: {
        url: `${this.$store.$global.static}/video/tenth-yearv3.m4v`,
        pic: 'https://file.xuantong.cn/images/origin/f1e2ffc4bc57f27415bc3972924d7d86.jpg'
      },
      screenshot: false,
      lang: 'zh-cn',
      autoplay: false
    }
  }

  onPause() {
    this.status = 'pause'
  }

  onPlay() {
    if (!this.howXtVideo) return

    this.howXtVideo.handlePlay()
    this.status = 'play'
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
